module.exports = __webpack_public_path__ + "static/media/duplicatedPig.b6323cf7.svg";